<template>
    <div>
        <page-header data-cy="user_index_title" :dropdown="this.$hasPermission('User_create') ? [{modal: false, emit:'exportClient', icon: 'icon-download', title: 'Exportar usuarios'}] : null"
                     :btnNew="this.$hasPermission('User_create') ? 'ACTIONS.NEW' : null"
                     pageTitle="USERS.INDEX_TITLE" @exportClient="exportClient()"
                     filter @filter="filtering" @newType="setRegisterModal"/>
        <div class="" v-if="items?.data?.length">
            <div class="row gutters">
                <div v-for="(iten, index) in items.data" :key="index"
                     class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="accordion" id="defaultAccordion">
                        <div class="accordion-container">
                            <div class="accordion-header "
                                 :id="'toggleIcons' + index">
                                <div class="d-flex flex-row justify-content-between">
                                    <div class="d-flex flex-column ">
                                        <p><i class="icon-user pr-1"></i>{{
                                                iten.name
                                            }} - {{ iten.taxpayer }}</p>
                                        <p style="font-size: 10px" class="color-grey"><i class="icon-email pr-1"></i>{{
                                                iten.email
                                            }}</p>
                                        <p style="font-size: 10px" class="color-grey"><i class="icon-phone pr-1"></i>
                                            {{ getOfRealtorData(iten.phones, 'phonesUser') }}</p>
                                    </div>
                                    <div class="d-flex flex-column text-right" style="min-width: max-content">
                                        <div class="text-right mt-2">
                                            <a type="button" data-toggle="dropdown" aria-haspopup="true"
                                               aria-expanded="false"
                                               style="font-size: 20px" id="listDropdown" class="w-100">
                                                <i class="icon-more_vert"/>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-menu-custom mw-100"
                                                 style="min-width: min-content !important;"
                                                 id="dropdownMenu">
                                                <div class="dropdown-item pointer text-white"
                                                     v-if="!verifyIsUserLoged(iten)"
                                                     @click.stop.prevent="setCompanyModal(iten, key)">
                                                    <i :class="iten.user_company.active ? 'icon-toggle-left mr-2' : 'icon-toggle-right mr-2'"/>
                                                    {{ iten.user_company.active ? 'Desativar' : 'Ativar' }}
                                                </div>
                                                <div class="dropdown-item pointer text-white"
                                                     @click.stop.prevent="setModalCopyLink(iten.id)"><i
                                                        class="icon-external-link mr-2"></i> Link Cadastro de
                                                    Cliente
                                                </div>
                                                <div class="dropdown-item pointer text-white"
                                                     @click.stop.prevent="setModalEditUser(iten)"><i
                                                        class="icon-pencil mr-2"></i>Editar Dados Pessoais
                                                </div>
                                                <div class="dropdown-item pointer text-white"
                                                     v-if="!verifyIsUserLoged(iten)"
                                                     @click.stop.prevent="setModalAlterPermissionGlobal(iten)"><i
                                                        class="icon-settings mr-2"></i>Alterar Grupos Global do Usuário
                                                </div>
                                                <div class="dropdown-item pointer text-white"
                                                     v-if="!verifyIsUserLoged(iten) && this.$hasPermission('security_clone_permission')"
                                                     @click.stop.prevent="sendUserAcessAllAllot(iten)"><i
                                                        class="icon-plus mr-2"></i>Conceder acesso a todos os loteamentos
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center pointer" @click.stop.prevent="openClose(index)">
                                    <i class="icon-chevron-up1"
                                       style="font-weight: 900; font-size: 16px; color: #0e5e4e"
                                       v-if="items.data[index].open"></i>
                                    <i class="icon-chevron-down1"
                                       style="font-weight: 900;font-size: 16px; color: #0e5e4e" v-else></i>
                                </div>
                                <div></div>
                            </div>
                            <div :id="'toggleIconsCollapse' + index" class="collapse"
                                 :aria-labelledby="'toggleIcons' + index"
                                 :data-parent="'#toggleIcons' + index"
                                 :class="{show: !!items.data[index].open}">
                                <div class="accordion-body p-3">
                                    <div class="row gutters">
                                        <div class="col-12 text-center" v-if="items.data[index].loading">
                                            <div class="spinner-border" role="status">
                                            </div>
                                        </div>
                                        <div v-else class="col-12">
                                            <div class="table-settings more-info border-top2 loading-box"
                                                 v-if="this.items.data[index].dontHaveAllotment">
                                                <div class="row gutters mt-2 mb-3">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                        <div class="text-center">
                                                            {{
                                                                t('GENERAL.MSG.NO_REGISTER', {
                                                                    name: t('ALLOTMENT.INDEX_TITLE'),
                                                                    os: t('os')
                                                                })
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12"
                                                 v-for="(ua, indexUa) in  this.items.data[index].userAllotments"
                                                 :key="indexUa">
                                                <div class="row gutters ">
                                                    <div class="col-12 w-100 card rounded mb-2">
                                                        <div class="text-center font-weight-bolder mt-1 ">
                                                            <div class="font-14"><p class="color-black"
                                                                                    :style="ua.allotment_id ? 'color: #0e5e4e' : 'color: #f54848'">
                                                                <i
                                                                        class="icon-grid mr-1"/>{{ ua.name }}:</p></div>
                                                        </div>
                                                        <div class="row p-3">
                                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                                                 v-if="!ua.allotment_id && !verifyIsUserLoged(iten)">
                                                                <div class="custom-control custom-switch">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                           :id="'active'+ua.id"
                                                                           v-model="ua.active"
                                                                           :disabled="!iten.user_company.active"
                                                                           @change="setAddUserAllotmentModal(ua, iten, iten.group_id, index, indexUa)">
                                                                    <label class="custom-control-label"
                                                                           :for="'active'+ua.id">{{
                                                                            t('USERS.GRANT_ACCESS')
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                                                                 v-if="ua.allotment_id">
                                                                <div class="form-group">
                                                                    <label class="color-grey font-seven"
                                                                           for="maxReserves">{{
                                                                            t('USERS.REAL_ESTATE_AGENCY')
                                                                        }}</label>
                                                                    <select2
                                                                            :placeholder="ua.real_estate_agency_name ? ua.real_estate_agency_name : 'Selecione'"
                                                                            :settings="ajaxPerson"
                                                                            :id="`${iten.id}${ua.id}`"
                                                                            @select="updateUserAllotment(ua, iten.id)"
                                                                            v-model="ua.real_estate_agency_id"
                                                                    ></select2>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                                                                 v-if="ua.allotment_id">
                                                                <div class="form-group">
                                                                    <label class="color-grey font-seven"
                                                                           for="maxReserves">{{
                                                                            t('GENERAL.QUANTITY_MAX_RESERVE')
                                                                        }}</label>
                                                                    <input data-cy="user_index_reserve_update"
                                                                           type="number"
                                                                           id="maxReserves"
                                                                           name="maxReserves"
                                                                           v-model="ua.max_number_reserves"
                                                                           class="form-control"
                                                                           :placeholder="t('GENERAL.QUANTITY_MAX_RESERVE')"
                                                                           @change="updateUserAllotment(ua, iten.id)"
                                                                           :disabled="!ua.active || !iten.user_company.active">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                                                                 v-if="ua.allotment_id">
                                                                <div class="form-group"
                                                                     v-if="configBrokerageType(ua, ua.brokerage_is_percentage)">
                                                                    <label for="brokerage">{{
                                                                            t('ALLOTMENT.BROKERAGE_VALUE')
                                                                        }}: </label>
                                                                    <div class="input-group">
                                                                        <input class="form-control" type="text"
                                                                               id="brokerage"
                                                                               name="brokerage"
                                                                               v-model.lazy="ua.brokerage_value"
                                                                               @focusout="updateUserAllotment({...ua}, iten.id)"
                                                                               v-money3="this.configBrokerage[ua.id]">
                                                                        <div class="input-group-prepend">
                                                                            <button class="btn btn-outline-secondary dropdown-toggle"
                                                                                    type="button"
                                                                                    data-toggle="dropdown"
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded="false">
                                                                                {{ t('GENERAL.TYPE') }}
                                                                            </button>
                                                                            <div class="dropdown-menu dropdown-menu-right">
                                                                                <a class="dropdown-item bg-hover-white"
                                                                                   @click="resetConfigBrokerage(ua,false)">{{
                                                                                        t('GENERAL.REAIS')
                                                                                    }}</a>
                                                                                <a class="dropdown-item bg-hover-white"
                                                                                   @click="resetConfigBrokerage(ua,true)">{{
                                                                                        t('GENERAL.PERCENTAGE')
                                                                                    }}</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                                                                 v-if="ua.allotment_id && !verifyIsUserLoged(iten)">
                                                                <div class="custom-control custom-switch">
                                                                    <input data-cy="user_index_active_checkbox"
                                                                           type="checkbox"
                                                                           class="custom-control-input"
                                                                           :id="'active'+ua.id"
                                                                           v-model="ua.active"
                                                                           @change="updateUserAllotment(ua, iten.id, true)"
                                                                           :disabled="!iten.user_company.active">
                                                                    <label class="custom-control-label"
                                                                           :for="'active'+ua.id">{{
                                                                            t('ALLOTMENT.ACTIVE')
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                                                                 v-if="ua.allotment_id">
                                                                <div class="custom-control custom-switch pt-1"
                                                                     v-if="ua.active">
                                                                    <input data-cy="user_index_active_checkbox"
                                                                           type="checkbox"
                                                                           class="custom-control-input"
                                                                           :id="'notify'+ua.id"
                                                                           v-model="ua.notify"
                                                                           @change="onOffNotificatonsUserAllotment(ua, iten.id)"
                                                                           :disabled="!ua.active">
                                                                    <label class="custom-control-label"
                                                                           :for="'notify'+ua.id">{{
                                                                            t('ALLOTMENT.NOTIFY')
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 mb-0"
                                                                 v-if="ua.allotment_id">
                                                                <p style="font-size: 10px" class="color-grey">
                                                                    <i class="icon-add-user pr-1"></i>
                                                                    Adicionando
                                                                    em:{{
                                                                        getDataCreated(ua)
                                                                    }}{{
                                                                        ua.created_by_name ? ", por: " + ua.created_by_name : ""
                                                                    }}
                                                                </p>
                                                            </div>
                                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 "
                                                                 v-if="ua.allotment_id && groupsCustom[iten.id][ua.allotment_id]?.groups">
                                                                <div class="dropdown-divider mt-3"></div>
                                                                <div style=" font-weight: 600;" class="mt-2 mb-2"><i
                                                                        class="icon-layers mr-1"></i>Grupos:
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                                                                         v-for="(group, keygroup) in groupsCustom[iten.id][ua.allotment_id]?.groups"
                                                                         :key="keygroup">
                                                                        <div class="custom-control custom-switch pt-1">
                                                                            <input data-cy="user_index_active_checkbox"
                                                                                   type="checkbox"
                                                                                   class="custom-control-input"
                                                                                   :id="`group-${iten.id}-${ua.allotment_id}-${keygroup}`"
                                                                                   v-model="group.active"
                                                                                   :disabled="verifyIsUserLoged(iten)"
                                                                                   @change="updateGroupCustom(iten, ua)">
                                                                            <label class="custom-control-label"
                                                                                   :for="`group-${iten.id}-${ua.allotment_id}-${keygroup}`">{{
                                                                                    getNameGroup(group.group_id)
                                                                                }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="false">
                <div v-for="(iten, key) in items.data" :key="iten.id" :class="key != 0 ? 'border-top2': ''">

                    <transition name="fade">
                        <div v-show="iten.open">

                            <div v-if="!iten.loading && !iten.dontHaveAllotment">
                                <div v-for="(userAllotment, allotmentKey) in iten.userAllotments"
                                     :key="userAllotment.id">
                                    <div class="table-settings more-info border-top2"
                                         :class="allotmentKey == 0 ? 'first-box': 'second-box'">
                                        <div class="row gutters align-items font-seven">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="card" v-if="!items?.data?.length">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NONE_USER_FOUND') }}</h5>
                </div>
            </div>
        </div>
        <pagination-component v-if="items && items.data && items.data[0]" :items="items" :to="'/usuario'"
                              @changePage="index(filters, $event)"></pagination-component>
        <input type="hidden" name="addUserModal" id="addUserModal" data-target="#add" data-toggle="modal">
        <modal :titleModal="modalTitle" :modal-xl="true" v-if="userCreate"
               @close="userCreate = null">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <create-users :company-index="JSON.parse(JSON.stringify(indexCompanyCreate))" :profilesIndex="profiles"
                          :userIndex="userCreate"
                          v-if="companies && userCreate && hasAllotment"
                          @create="index(filters)">
            </create-users>
        </modal>
        <modal :titleModal="modalTitle" :modal-xl="true" v-if="modalEdit" @close="closeModalEdit">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <editUser-component :item-index="userEdit" @updated="index(filters)"></editUser-component>
        </modal>
        <modal :titleModal="modalTitle" :modal-xl="true" v-if="modalPermissionGlobal" @close="closeModalEdit">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Usuário</label>
                                <input type="text" disabled class="form-control" v-model="userPermission.name">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">E-mail</label>
                                <input type="text" disabled class="form-control" v-model="userPermission.email">
                            </div>
                        </div>
                    </div>
                    <div class="text-center font-weight-bolder mt-1 ">
                        <div style=" font-weight: 600; color: #0e5e4e" class="mt-2 mb-2"><i
                                class="icon-layers mr-1"></i>Grupos:
                        </div>
                    </div>
                    <div class="row" v-if="userPermission?.user_company?.groups">
                        <div class="col-4" v-for="(group, keyGroup) in  userPermission.user_company.groups"
                             :key="keyGroup">
                            <div class="custom-control custom-switch pt-1">
                                <input data-cy="user_index_active_checkbox"
                                       type="checkbox"
                                       class="custom-control-input"
                                       :id="`group-global-${keyGroup}`"
                                       v-model="group.active">
                                <label class="custom-control-label"
                                       :for="`group-global-${keyGroup}`">{{
                                        getNameGroup(group.group_id)
                                    }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="closeModalEdit" data-dismiss="modal">Fechar</button>
                    <button class="btn btn-primary" v-if="!verifyIsUserLoged(this.userPermission)"
                            @click="updateGroupGlobal(userPermission)">Salvar
                    </button>
                </div>
            </div>
        </modal>
        <modal :titleModal="modalTitle" :modal-xl="true" v-if="wichModal === 2" @close="closeModalEdit">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <div class="modal-content">
                <div class="modal-body modal-open modal-height-max">
                    <div class="row gutters">
                        <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group">
                                <input type="text" name="company" v-model="allotmentModal" id="company"
                                       class="form-control mb-2" @keyup="selectAllotmentModal"
                                       placeholder="Digite o nome do loteamento para buscar">
                                <div class="justify-content-center modal-row2">
                                    <div v-for="allotment in [{id:'nenhum', text:'Nenhum'},...allotments]"
                                         :key="allotment.id">
                                        <button class="btn btn-background mt-1" @click="copyLink(allotment.id)">
                                            {{ allotment.text }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <modal :titleModal="modalTitle" modal-large v-if="wichModal === 1">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <div class="modal-body">
                <div class="row gutters">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="form-group">
                            <label for="filter_name">Nome</label>
                            <input type="text" class="form-control" v-model="filters.name" id="filter_name"
                                   placeholder="Nome">
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="form-group">
                            <label>Tipo de Acesso na companhia</label>
                            <select2 placeholder="Selecione" :settings="{width: '100%'}" v-model="filters.typeUser"
                                     :options="[{id:'selecione', text:'selecione'}, ...profiles]"
                            ></select2>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="form-group">
                            <label for="lter_email">E-mail</label>
                            <input type="text" class="form-control" id="lter_email" v-model="filters.email"
                                   placeholder="E-mail">
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="form-group">
                            <label for="filter_taxpayer">CPF/CNPJ</label>
                            <input type="text" class="form-control" id="filter_taxpayer" v-model="filters.taxpayer"
                                   placeholder="CPF/CNPJ">
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="form-group">
                            <label for="filter_phone">Telefone</label>
                            <input type="text" class="form-control" v-model="filters.phone" id="filter_phone"
                                   placeholder="Telefone">
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="form-group">
                            <label for="filter_creci">CRECI</label>
                            <input type="text" class="form-control" id="filter_creci" v-model="filters.creci"
                                   placeholder="Creci">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeFilter">Limpar</button>
                <button class="btn btn-primary" @click="this.filterIndex()">Filtrar</button>
            </div>
        </modal>
        <div class="modal fade" id="add" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true"
             data-backdrop="static" style="position: fixed;">
            <button type="button" class="closeX" id="closeModal" data-dismiss="modal" aria-label="Close"
                    hidden></button>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div data-cy="user_update_title" class="modal-header hearder-custom">
                        <h4 class="modal-title title-size" v-if="modalTitle">{{ t(modalTitle) }}</h4>
                        <button type="button" class="close close-custom" id="close" data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row gutters custom-margin">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group" v-if="allotment">
                                    <label>{{ t('LOTS.ALLOTMENT') }}: </label>
                                    <label class="ml-1 color-grey">{{ allotment }}</label>
                                </div>
                                <div class="form-group" v-if="!allotment">
                                    <label>{{ t('NAV.COMPANY') }}: </label>
                                    <label class="ml-1 color-grey">{{ companyName }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row gutters">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group" v-if="name">
                                    <label>{{ t('RESERVE.REALTOR') }}: </label>
                                    <label class="ml-1 color-grey">{{ name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="right">
                            <button id="close_modal" type="button" class="btn btn-secondary  mr-1 width-buttons"
                                    data-dismiss="modal"
                                    @click="closeModal">{{ t('ACTIONS.CLOSE') }}
                            </button>
                            <button type="button" class="btn btn-primary mr-1 width-buttons" @click="addUserAllotment"
                                    v-if="allotment">{{ t('ACTIONS.CONFIRM') }}
                            </button>
                            <button data-cy="user_index_confirm_update" type="button"
                                    class="btn btn-primary mr-1 width-buttons"
                                    @click="updateUserCompanhie(this.userCompanyGroup, true)" v-if="!allotment">
                                {{ t('ACTIONS.CONFIRM') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {useI18n} from "vue-i18n";
import User from '@/services/user';
import Group from '@/services/Group';
import Modal from "@/components/modal";
import {useToast} from "vue-toastification";
import Select2 from 'vue3-select2-component';
import Allotments from '@/services/Allotments';
import Validate from '@/components/validate.vue';
import createUsers from "./createUsersComponent.vue";
import UserCompany from '@/services/UserCompanies.js';
import UserAllotment from '@/services/UserAllotment.js';
import pageHeader from "@/components/layouts/pageHeader";
import PaginationComponent from "@/components/layouts/PaginationComponent";
import editUserComponent from './editUserComponent';
import {Money3Directive} from 'v-money3';
import isReator from '../../mixins/isReator';
import {mapState} from 'vuex';
import jwt_decode from 'jwt-decode';
import moment from 'moment-timezone';
import Public from '../../services/Public';

export default {
    name: 'indexUser',
    mixins: [Validate, isReator],
    directives: {money3: Money3Directive},
    components: {
        Modal,
        Select2,
        editUserComponent,
        pageHeader,
        createUsers,
        PaginationComponent
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    computed: {
        ...mapState({
            allotmentsBackup: 'allotmentsOnlyUserAllo',
        })
    },
    watch: {
        allotmentsBackup() {
            this.allotments = this.allotmentsBackup
        }
    },
    data() {
        return {
            allotmentAux: [],
            groupsCustom: {},
            indexCompanyCreate: {},
            allotments: [],
            allotmentModal: '',
            ajaxPerson: {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return "Por favor, insira ao menos 1 caracteres para pesquisar.";
                    },
                    noResults: function () {
                        return "Nenhum resultado encontrado!";
                    }
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/clientes/list?onlyRealState=true`,
                    dataType: "json",
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                    },
                    data: params => {
                        return {
                            term: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id: 0, text: "Nenhum"});
                            return {
                                results: data.map((i) => ({id: i.id, text: i.text}))
                            };
                        } else {
                            return {results: {id: 0, text: "Nenhum"}};
                        }
                    },
                    cache: true
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
            filters: {},
            name: null,
            items: null,
            userIdCopy: null,
            profiles: [],
            filter: null,
            userKey: null,
            allotment: null,
            userEdit: {},
            userPermission: {},
            userCreate: null,
            modalTitle: null,
            companyName: null,
            userAllotment: {},
            hasAllotment: null,
            modalEdit: false,
            modalPermissionGlobal: false,
            userCompanyGroup: {},
            companies: JSON.parse(localStorage.getItem('companies')),
            configBrokerage: [],
            wichModal: null,
            promiseIndexCompany: null,
            user: {},
        }
    },
    mounted() {
        this.$canAccess('security_index_user');
        if (this.isRealtor()) {
            this.$router.push({name: 'Home'});
            return;
        }
        this.$store.commit('changeLoading', true);
        this.indexCompany();
        this.indexGroup();
        this.index();
    },
    methods: {
        getDataCreated(ua) {
            const date = moment(ua.created_at).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm:ss");
            return ' ' + date;
        },
        getNameGroup(id) {
            let group = this.profiles.find(i => id === i.id);
            return group?.text ? group.text : '';
        },
        openClose(key) {
            this.items.data[key].open = !this.items.data[key].open;
            if (this.items.data[key].loading === undefined) {
                this.items.data[key].loading = true;
                UserAllotment.getAllotmentsById(this.items.data[key].id).then(resp => {
                    let arrayOfId = [];
                    if (resp.data.validations) {
                        this.items.data[key].userAllotments = [];
                    } else {
                        resp.data.forEach(item => {
                            arrayOfId.push(item.allotment_id);
                            if (item.brokerage_value) {
                                item.brokerage_value = parseFloat(item.brokerage_value).toFixed(2);
                            }
                            this.groupsCustom[this.items.data[key].id][item.allotment_id] = {};
                            let us = this.items.data[key].user_company.user_scope_custom?.find(usc => usc.scope_ref === item.allotment_id);
                            let grops = us?.groups?.map(gus => {
                                return {
                                    id: gus.pivot.id,
                                    active: gus.pivot.active,
                                    group_id: gus.pivot.group_id,
                                }
                            })
                            this.groupsCustom[this.items.data[key].id][item.allotment_id] = {
                                scope_ref: item.allotment_id,
                                groups: []
                            };
                            this.profiles.forEach(p => {
                                let gFind = grops?.find(g => parseInt(g.group_id) === parseInt(p.id))
                                if (gFind) {
                                    this.groupsCustom[this.items.data[key].id][item.allotment_id].groups.push(gFind);
                                } else {
                                    this.groupsCustom[this.items.data[key].id][item.allotment_id].groups.push({
                                        group_id: p.id,
                                    });
                                }
                                const mapaNomes = Object.fromEntries(this.profiles.map(n => [n.id, n.text]));
                                this.groupsCustom[this.items.data[key].id][item.allotment_id].groups.sort((a, b) => {
                                    const nomeA = mapaNomes[a.group_id] || "";
                                    const nomeB = mapaNomes[b.group_id] || "";
                                    return nomeA.localeCompare(nomeB);
                                });
                            })
                        });
                        this.items.data[key].userAllotments = resp.data;
                    }
                    Allotments.listForUsers(true, true).then(re => {
                        let allotments = [];
                        if (!re.data.validations) {
                            re.data.forEach(allotment => {
                                let teste = arrayOfId.find(id => id == allotment.id);
                                if (teste) {
                                    let allotUser = this.items.data[key].userAllotments.find((i) => i.allotment_id === allotment.id);
                                    if (allotUser) {
                                        allotments.push(allotUser)
                                    } else {
                                        allotments.push({id: allotment.id, name: allotment.text});
                                    }
                                } else {
                                    allotments.push({id: allotment.id, name: allotment.text});
                                }
                            });
                        } else {
                            this.items.data[key].dontHaveAllotment = true;
                        }
                        this.items.data[key].userAllotments = allotments;
                        this.items.data[key].loading = false;
                    })
                }).catch(error => {
                    this.items.data[key].loading = undefined;
                    this.errorMsg(error);
                });
            }
        },
        getOfRealtorData(realtor_data, action) {
            if (typeof realtor_data === "string") {
                realtor_data = JSON.parse(realtor_data);
            }
            var phone = "";
            switch (action) {
                case 'name':
                    return realtor_data.name;
                case 'taxpayer':
                    return realtor_data.taxpayer;
                case 'email':
                    return realtor_data.email;
                case 'phones':
                    for (const p of realtor_data.phones) {
                        phone = phone + `${p.number}; `;
                    }
                    return phone;
                case 'phonesUser':
                    for (const p of realtor_data) {
                        phone = phone + `${p.number}; `;
                    }
                    return phone;
            }
        },
        selectAllotmentModal() {
            this.allotmentAux = [];
            this.allotments = this.allotmentsBackup;
            this.allotments.forEach(company => {
                const text = company.text.toUpperCase();
                const textModal = this.allotmentModal.toUpperCase();
                if (text.includes(textModal)) {
                    this.allotmentAux.push(company);
                }
            });
            this.allotments = this.allotmentAux;
        },
        filtering() {
            this.modalEdit = false;
            this.modalPermissionGlobal = false;
            this.userCreate = null;
            this.wichModal = 1;
            this.modalTitle = "Filtro";
        },
        closeFilter() {
            this.filters = {};
            document.getElementById('closeX')?.click();
            this.index(this.filters);
            this.wichModal = null;
        },
        filterIndex() {
            if (this.filters.typeUser === 'selecione') {
                delete this.filters.typeUser;
            }
            document.getElementById('closeX')?.click();
            this.index(this.filters);
        },
        resetConfigBrokerage(user, type) {
            user.brokerage_value = 0;
            user.brokerage_is_percentage = type;
            this.setConfigBrokerage(type, user.id);
        },
        closeModalEdit() {
            this.wichModal = null;
            this.userCreate = null;
            this.modalEdit = false;
            this.modalPermissionGlobal = false;
            this.userEdit = {};
            this.modalTitle = '';
        },
        setModalEditUser(user) {
            let div = document.createElement('div');
            div.setAttribute('data-toggle', 'modal');
            div.setAttribute('data-target', '#customModalTwo');
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(div);
            setTimeout(function () {
                div.click();
                div.remove();
            }, 100);
            this.userCreate = null;
            this.modalPermissionGlobal = null;
            this.modalEdit = true;
            this.userEdit = user;
            this.modalTitle = 'Editar Usuário';
        },
        async sendUserAcessAllAllot(user) {
            this.$store.commit('changeLoading', true);
            console.log(user)
            await UserCompany.getScopeGlobalByUserCompanyId(user.user_company.id).then(resp => {
                let groups = [];
                resp?.data?.groups?.forEach(i => {
                    groups.push({
                        name: i.name,
                        id: i.id,
                        active: i.active
                    });
                })
                if (groups?.length) {
                    let text = '';
                    groups.forEach(i => {
                        text = text + i.name + ' - ' + `${i.active ? "ativo" : "inativo"}; `;
                    });
                    this.$swal.fire({
                        title: `Realmente deseja conceder acesso ao usuario ${user.name} em todos os loteamentos em que nao possui acesso?`,
                        text: `Grupos: ${text}`,
                        showCancelButton: true,
                        showCloseButton: true,
                        confirmButtonText: 'Conceder',
                        cancelButtonText: 'Cancelar'
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.$store.commit('changeLoading', true);
                            UserAllotment.concedAccessInAllAllotment({
                                user_company_id: user.user_company.id,
                                user_id: user.id,
                            }).then(() => {
                                this.index(this.filters);
                                this.toast.success('Registros Enviados para fila de processamento!');
                            }).catch((err) => {
                                this.$store.commit('changeLoading', false);
                                this.errorMsg(err);
                            })
                        }
                    });
                } else {
                    this.toast.error('Usuario nao possui grupos globais!');
                }
                this.$store.commit('changeLoading', false);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        async setModalAlterPermissionGlobal(user) {
            this.$store.commit('changeLoading', true);
            this.userPermission = JSON.parse(JSON.stringify(user));
            let div = document.createElement('div');
            div.setAttribute('data-toggle', 'modal');
            div.setAttribute('data-target', '#customModalTwo');
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(div);
            setTimeout(function () {
                div.click();
                div.remove();
            }, 100);
            this.userEdit = null;
            this.userCreate = null;
            this.modalEdit = null;
            let groups = [];
            this.modalPermissionGlobal = true;
            this.modalTitle = 'Alterar Grupos do Usuário';
            await UserCompany.getScopeGlobalByUserCompanyId(this.userPermission.user_company.id)
                    .then(resp => {
                        this.userPermission.user_company.user_scope_global = resp.data;
                        this.profiles.forEach(p => {
                            let gFind = this.userPermission?.user_company?.user_scope_global?.groups?.find(g => parseInt(g.id) === parseInt(p.id))
                            if (gFind) {
                                groups.push({
                                    id: gFind.pivot.id,
                                    group_id: gFind.pivot.group_id,
                                    active: gFind.pivot.active,
                                });
                            } else {
                                groups.push({
                                    group_id: p.id,
                                });
                            }
                        });
                        this.userPermission.user_company.groups = groups;
                        this.$store.commit('changeLoading', false);
                    }).catch(err => {
                        document.getElementById('closeX')?.click();
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    })
        },
        closeModalPermissionGlobal() {
            document.getElementById('closeX')?.click();
            this.userEdit = null;
            this.userCreate = null;
            this.modalEdit = null;
            this.userPermission = null;
            this.modalPermissionGlobal = null;
            this.modalTitle = '';
        },
        setModalCopyLink(id) {
            this.allotments = this.allotmentsBackup;
            let div = document.createElement('div');
            div.setAttribute('data-toggle', 'modal');
            div.setAttribute('data-target', '#customModalTwo');
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(div);
            setTimeout(function () {
                div.click();
                div.remove();
            }, 100);
            this.wichModal = 2;
            this.modalTitle = "Selecione um loteamento";
            this.userIdCopy = id;
        },
        async copyLink(allotmentId) {
            this.$store.commit('changeLoading', true);
            await Public.getUuidUserByExtenalId(this.userIdCopy).then(async resp => {
                const id = resp.data;
                let link;
                if (allotmentId === 'nenhum') {
                    link = window.location.origin + `/cliente-publico/${localStorage.getItem('companyId')}/${id}`;
                } else {
                    link = window.location.origin + `/cliente-publico/${localStorage.getItem('companyId')}/${id}/${allotmentId}`;
                }
                await Public.getLinkCut(link).then(resp => {
                    this.$store.commit('changeLoading', false);
                    const inputTemporario = document.createElement('input');
                    inputTemporario.value = resp.data.link;
                    document.body.appendChild(inputTemporario);
                    inputTemporario.select();
                    document.execCommand('copy');
                    document.body.removeChild(inputTemporario);
                    this.toast.success('Link copiado com sucesso!');
                    document.getElementById('closeX').click();
                }).catch(() => this.$store.commit('changeLoading', false));
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        setConfigBrokerage(type, id) {
            if (type) {
                this.configBrokerage[id].max = 100;
                this.configBrokerage[id].prefix = '';
                this.configBrokerage[id].decimal = '.';
                this.configBrokerage[id].thousands = '';
                this.configBrokerage[id].suffix = '%';
                this.configBrokerage[id].disabled = false;
                this.configBrokerage[id].minimumNumberOfCharacters = 0;
            } else {
                this.configBrokerage[id].suffix = '';
                this.configBrokerage[id].decimal = ',';
                this.configBrokerage[id].thousands = '.';
                this.configBrokerage[id].prefix = 'R$ ';
                this.configBrokerage[id].disabled = false;
                this.configBrokerage[id].disableNegative = true;
                this.configBrokerage[id].max = 100000000000;
                this.configBrokerage[id].minimumNumberOfCharacters = 1;
            }
        },
        validateMoney3(value) {
            if (value % 2 == 0) {
                return value * 100;
            } else {
                return value;
            }
        },
        configBrokerageType(user, type) {
            let id = user.id;
            if (this.configBrokerage[id]) {
                return true;
            }
            if (type) {
                this.configBrokerage[id] = {};
                this.configBrokerage[id].max = 100;
                this.configBrokerage[id].prefix = '';
                this.configBrokerage[id].decimal = '.';
                this.configBrokerage[id].thousands = '';
                this.configBrokerage[id].suffix = '%';
                this.configBrokerage[id].disabled = false;
                this.configBrokerage[id].minimumNumberOfCharacters = 0;
            } else {
                this.configBrokerage[id] = {};
                this.configBrokerage[id].suffix = '';
                this.configBrokerage[id].decimal = ',';
                this.configBrokerage[id].thousands = '.';
                this.configBrokerage[id].prefix = 'R$ ';
                this.configBrokerage[id].disabled = false;
                this.configBrokerage[id].disableNegative = true;
                this.configBrokerage[id].max = 100000000000;
                this.configBrokerage[id].minimumNumberOfCharacters = 1;
            }
            return this.configBrokerage[id];
        },
        indexCompany() {
            this.indexCompanyCreate = this.companies.find(i => i.id === localStorage.getItem('companyId'));
            this.promiseIndexCompany = UserAllotment.listCompanyAllotment().then(resp => {
                this.indexCompanyCreate.allotments = resp.data;
                this.hasAllotment = resp.data.length >= 1;
            }).catch(error => {
                this.indexCompanyCreate.allotments = [];
                this.errorMsg(error)
            });
        },
        indexGroup() {
            Group.list().then(resp => {
                this.profiles = resp.data;
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error)
            });
        },
        setRegisterModal() {
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'USERS.MODAL_TITLE.ADD';
            this.wichModal = null;
            this.modalEdit = false;
            this.userCreate = {
                user: {
                    name: null,
                    phones: [],
                    email: null,
                    creci: null,
                    active: true,
                    password: null,
                    scope: "",
                },
                userCompaniesGroups: []
            }
            this.promiseIndexCompany.finally(() => this.$store.commit('changeLoading', false));
        },
        async index(filter = null, page = 1) {
            this.userCreate = null;
            this.$store.commit('changeLoading', true);
            this.companyName = this.companies.find(c => c.id == localStorage.getItem('companyId'))?.text;
            await User.indexUserOnOauth(filter, page).then(resp => {
                this.groupsCustom = {};
                resp?.data.data.forEach(i => {
                    this.groupsCustom[i.id] = {};
                });
                this.items = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },
        open(user, isReload = false, add = false) {
            if (!add) {
                user.open = !user.open ? true : false;
            }
            if (user.open && !user.userAllotments || isReload) {
                user.loading = true;
                UserAllotment.getAllotmentsById(user.id).then(resp => {
                    let arrayOfId = [];
                    if (resp.data.validations) {
                        user.userAllotments = [];
                    } else {
                        resp.data.forEach(item => {
                            arrayOfId.push(item.allotment_id);
                            if (item.brokerage_value) {
                                item.brokerage_value = parseFloat(item.brokerage_value).toFixed(2);
                            }
                        });
                        user.userAllotments = resp.data;
                    }
                    Allotments.listForUsers(true, true).then(re => {
                        let allotments = [];
                        if (!re.data.validations) {
                            re.data.forEach(allotment => {
                                let teste = arrayOfId.find(id => id == allotment.id);
                                if (teste) {
                                    let allotUser = user.userAllotments.find((i) => i.allotment_id === allotment.id);
                                    if (allotUser) {
                                        allotments.push(allotUser)
                                    } else {
                                        allotments.push({id: allotment.id, name: allotment.text});
                                    }
                                } else {
                                    allotments.push({id: allotment.id, name: allotment.text});
                                }
                            });
                        } else {
                            user.dontHaveAllotment = true;
                        }
                        user.userAllotments = allotments;
                        user.loading = false;
                    })
                }).catch(error => {
                    user.loading = false;
                    this.errorMsg(error);
                });
            }
        },
        onOffNotificatonsUserAllotment(userAllotment, userId) {
            this.$store.commit('changeLoading', true);
            userAllotment.user_id = userId;
            let brokerageValueFinal;
            if (userAllotment.brokerage_is_percentage) {
                brokerageValueFinal = userAllotment.brokerage_value.replaceAll("%", "");
                brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
            } else {
                brokerageValueFinal = userAllotment.brokerage_value.replaceAll("R$ ", "");
                brokerageValueFinal = brokerageValueFinal.replaceAll(".", "");
                brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
            }
            userAllotment.brokerage_value = brokerageValueFinal;
            UserAllotment.update(userAllotment).then(() => {
                this.$store.commit('changeLoading', false);
                if (userAllotment.notify) {
                    this.toast.success(this.t('USERS.NOTIFY_ALLOWED'));
                } else {
                    this.toast.success(this.t('USERS.NOTIFY_DENIED'));
                }
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },
        updateUserAllotment(userAllotment, userId, isSwitch = false) {
            this.$store.commit('changeLoading', true);
            userAllotment.user_id = userId;
            let brokerageValueFinal;
            if (userAllotment.brokerage_is_percentage) {
                brokerageValueFinal = userAllotment.brokerage_value.replaceAll("%", "");
                brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
            } else {
                brokerageValueFinal = userAllotment.brokerage_value.replaceAll("R$ ", "");
                brokerageValueFinal = brokerageValueFinal.replaceAll(".", "");
                brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
            }
            userAllotment.brokerage_value = brokerageValueFinal;
            if (userAllotment.real_estate_agency_id === '0') {
                userAllotment.real_estate_agency_id = null;
                userAllotment.real_estate_agency_name = null;
            }
            UserAllotment.update(userAllotment).then(() => {
                this.$store.commit('changeLoading', false);
                if (isSwitch && userAllotment.active) {
                    this.toast.success(this.t('GENERAL.MSG.ACCESS_GRANTED_WITH_SUCCESS'));
                } else if (isSwitch && !userAllotment.active) {
                    this.toast.success(this.t('GENERAL.MSG.ACCESS_DENIED_WITH_SUCCESS'));
                } else {
                    this.toast.success('Usuário Atualizado');
                }
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },
        updateGroupGlobal(i) {
            let data = {};
            data.user_company_id = i.user_company.id;
            data.groups = i.user_company?.groups?.filter(g => {
                if (g.id || g.active) {
                    return g;
                }
            })
            this.$store.commit('changeLoading', true);
            UserCompany.updateGlobalGroup(i.user_company.id, data).then(() => {
                this.closeModalPermissionGlobal();
                this.toast.success('Grupo Atualizado com Sucesso!');
                this.$store.commit('changeLoading', false);
            }).catch(err => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            })
        },
        updateGroupCustom(i, ua) {
            let data = JSON.parse(JSON.stringify(this.groupsCustom[i.id][ua.allotment_id]));
            data.user_company_id = i.user_company.id;
            data.description = `Loteamento - ${ua.name}`;
            data.groups = data.groups?.filter(g => {
                if (g.id || g.active) {
                    return g;
                }
            })
            this.$store.commit('changeLoading', true);
            UserCompany.setCusomGroup(data).then(resp => {
                let group = [];
                resp.data?.forEach(g => {
                    group.push({
                        group_id: g.group_id,
                        id: g.id,
                        active: g.active,
                    });
                })
                this.profiles.forEach(p => {
                    let gFind = group.find(g => g.group_id === p.id);
                    if (!gFind) {
                        group.push({
                            group_id: p.id,
                        });
                    }
                });
                const mapaNomes = Object.fromEntries(this.profiles.map(n => [n.id, n.text]));
                group.sort((a, b) => {
                    const nomeA = mapaNomes[a.group_id] || "";
                    const nomeB = mapaNomes[b.group_id] || "";
                    return nomeA.localeCompare(nomeB);
                });
                this.groupsCustom[i.id][ua.allotment_id].groups = group;
                this.toast.success('Grupo Atualizado com Sucesso!');
                this.$store.commit('changeLoading', false);
            }).catch(err => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            })
        },
        verifyIsUserLoged(i) {
            if (localStorage.getItem('access_token')) {
                let userLoged = jwt_decode(localStorage.getItem('access_token'));
                if (userLoged) {
                    return i.id === userLoged.idUsuario;
                }
                return false;
            }
            return false;
        },
        updateUserCompanhie(userCompany, isSwitch = false, isCategory) {
            this.$store.commit('changeLoading', true);
            if (isCategory) {
                userCompany = {
                    user_id: userCompany.id,
                    active: userCompany.active,
                    company_id: userCompany.company_id,
                    group_id: userCompany.group_id,
                    id: userCompany.users_companies_groups_id
                }
                UserAllotment.updatePermission(userCompany).then(() => {
                    UserCompany.update(userCompany).then(() => {
                        this.$store.commit('changeLoading', false);
                        if (isSwitch && userCompany.active) {
                            this.toast.success(this.t('GENERAL.MSG.ACCESS_GRANTED_WITH_SUCCESS'));
                        } else if (isSwitch && !userCompany.active) {
                            this.toast.success(this.t('GENERAL.MSG.ACCESS_DENIED_WITH_SUCCESS'));
                        } else {
                            this.toast.success(this.t('GENERAL.MSG.GRUOP_UPDATED_SUCCESS'));
                        }
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    })
                }).catch((err) => {
                    this.$store.commit('changeLoading', false);

                    if (err.response.status === 401) {
                        this.toast.error(this.t(err.response.data.message), {timeout: false});
                    } else {
                        this.toast.error(this.t(err.response.data.message), {timeout: false});
                    }
                })
            } else {
                UserCompany.onOff(this.user.user_company.id).then(() => {
                    this.items.data.forEach((i) => {
                        if (i.id === this.user.id) {
                            if (!i.user_company.active) {
                                this.toast.success(this.t('GENERAL.MSG.ACCESS_GRANTED_WITH_SUCCESS'));
                            } else {
                                this.toast.success(this.t('GENERAL.MSG.ACCESS_DENIED_WITH_SUCCESS'));
                            }
                            i.user_company.active = !i.user_company.active;
                        }
                    })
                    this.$store.commit('changeLoading', false);
                    document.getElementById('closeModal').click();
                }).catch(error => {
                    document.getElementById('closeModal').click();
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(error);
                });
            }
        },
        async setAddUserAllotmentModal(userAllotment, user, group_id, key, allotmentKey) {
            this.$store.commit('changeLoading', true);
            await UserCompany.getScopeGlobalByUserCompanyId(user.user_company.id)
                    .then(resp => {
                        let groups = [];
                        resp.data.groups?.forEach(i => {
                            if (i.pivot.active) {
                                groups.push({"group_id": i.id});
                            }
                        });
                        this.userAllotment =
                                {
                                    active: true,
                                    user_company_id: user.user_company.id,
                                    user_id: user.id,
                                    max_number_reserves: 2,
                                    allotment_id: userAllotment.id,
                                    description: userAllotment.name,
                                    groups: groups,
                                };
                        this.name = user.name;
                        this.allotment = userAllotment.name;
                        this.modalTitle = 'USERS.MODAL_TITLE.REALY_WHANT_GRANT_ACCESS_ALLOTMENT';
                        this.userKey = {key: key, allotmentKey: allotmentKey, action: 'grant_access'};
                        document.getElementById('addUserModal').click();
                        this.$store.commit('changeLoading', false);
                    }).catch(err => {
                        document.getElementById('closeX')?.click();
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    })
        },
        async addUserAllotment() {
            this.items[this.userKey.key] = false;
            if (!this.userAllotment?.groups?.length) {
                this.toast.error('Usuário não possui acesso global');
                return;
            }
            this.$store.commit('changeLoading', true);
            await UserAllotment.create(this.userAllotment, this.userAllotment.allotment_id).then(async (resp) => {
                await this.index(this.filters);
                this.toast.success(this.t('GENERAL.MSG.ACCESS_GRANTED_WITH_SUCCESS'));
                let id = resp.data.user_id;
                document.getElementById('closeModal').click();
                this.items.data.forEach((item, key) => {
                    if (item.id == id) {
                        this.openClose(key);
                    }
                });
                if (this.userKey.action === 'grant_access'){
                    this.userKey.action = null;
                    this.openClose(this.userKey.key);
                }
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
        },
        setCompanyModal(user, key) {
            if (this.verifyIsUserLoged(user)) {
                return;
            }
            this.user = JSON.parse(JSON.stringify(user));
            this.user.active = !this.user.active;
            this.name = user.name;
            this.allotment = null;
            this.userKey = {key: key, allotmentKey: null};
            this.userCompanyGroup = {
                user_id: user.id,
                active: user.active,
                group_id: user.group_id,
                company_id: user.company_id,
                id: user.users_companies_groups_id,
            }
            this.modalTitle = `Realmente deseja ${this.user.user_company.active ? 'Inativar' : 'Ativar'} este usuario?`;
            document.getElementById('addUserModal').click();
        },
        closeModal() {
            if (this.allotment) {
                this.items.data[this.userKey.key].userAllotments[this.userKey.allotmentKey].active = false;
            } else {
                if (this.user?.id) {
                    this.items.data?.forEach((i, k) => {
                        if (i.id === this.user.id) {
                            this.user.active = !this.user.active;
                            this.items.data[k] = this.user;
                        }
                    })
                    this.user = {};
                } else {
                    this.items.data[this.userKey.key].active = !this.items[this.userKey.key].active;
                }
            }
        },
        paddingGroup() {
            return this.widthPhone() ? {
                'padding-left': '1rem',
                'padding-right': '1rem',
                'margin-top': '0.5rem',
                'margin-bottom': '0.5rem'
            } : {'padding-right': '1.5rem'};
        },
        search(filter) {
            this.filter = filter;
            this.index(filter);
        },
        exportClient(){
            this.$store.commit('changeLoading', true);
            User.exportUsersAlotment('all').then((resp) => {
                this.$store.commit('changeLoading', false);
                this.downloadFile(resp.data, 'usuarios.xlsx');
                this.toast.success('Exportado com sucesso!');
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        downloadFile(blobData, fileName) {
            const url = window.URL.createObjectURL(new Blob([blobData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
    },
}
</script>

<style>
.paddin {
    padding-left: 1rem !important;
    padding-top: 0.75rem !important;
    padding-bottom: 0.5rem !important;
}

.button-center {
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    border-radius: 50px;
    font-size: 160%;
}

.pointer {
    cursor: pointer;
}

.user-name {
    color: #000;
    padding: 0rem 0rem 0rem 1.5rem;
    font: 400 0.8rem 'Open Sans', sans-serif;
}

.status-active {
    padding: 0.5rem 1.5rem 0rem 1.5rem;
    font-size: 0.7rem !important;
}

.color-grey {
    color: #727272;
}

.btn-holver {
    border: none;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    transition-duration: 0.4s;
}

.bg-btn {
    background-color: #f2f4f9 !important;
    color: black !important;
}

.bg-btn:hover {
    background-color: #0e5e4e !important;
    color: white !important;
}

.table-settings {
    padding-top: 0.6rem !important;
    padding-right: 1rem !important;
    background-color: white !important;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */
{
    opacity: 0;
}

.more-info {
    padding-left: 2rem !important;
    background-color: rgb(245, 245, 245);
}

.color-black {
    color: #000;
}

.active-general {
    max-width: 75px;
    border-radius: 1rem;
    color: white;
}

.space-between {
    padding-bottom: 8px;
    align-items: center;
    justify-content: space-between;
}

.align-items {
    align-items: center;
}

.font-seven {
    font-size: 0.7rem !important;
}

.ptb {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.hearder-custom {
    color: #000 !important;
    background-color: white !important;
}

.title-size {
    font-size: 1rem !important;
}

.close-custom {
    color: #000 !important;
}

.right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end !important;
    border-bottom-right-radius: calc(.3rem - 1px);
    border-bottom-left-radius: calc(.3rem - 1px);
}

.width-buttons {
    width: 30%;
}

.first-box {
    box-shadow: inset 0px 1px 5px rgb(139 139 139 / 35%) !important;
}

.second-box {
    box-shadow: inset 0px -1px 5px rgb(139 139 139 / 35%) !important;
}

.loading-box {
    padding-bottom: 0.1rem;
    box-shadow: inset 0px 0px 5px rgb(139 139 139 / 35%) !important;
}
</style>
